module.exports = __webpack_public_path__ + "static/img/box-open.53cba953.png";